module.exports = __webpack_public_path__ + "static/media/detalle-verde.be569338.svg";